'use client';

import { useEffect, useRef } from 'react';
import { useAlertModalStore } from '../../store/alertModalStore';
import { trackNaverPageView } from '../../utils/common/naver-script';
import { SESSION_STORAGE_KEYS } from '../../utils/common/session-storage-keys';
import { usePathnameMethod } from '../../utils/hook/usePathnameMethod';

/**
 * pathname이 변경될 때마다 이전 경로를 세션 스토리지에 저장
 */
export const LayoutNavigationEvents = () => {
  const setAlertModal = useAlertModalStore.use.setAlertModal();
  const { pathname, search } = usePathnameMethod();

  useEffect(() => {
    return () => {
      setAlertModal(null);
      window.sessionStorage.setItem(
        SESSION_STORAGE_KEYS.PREVIOUS_PATH,
        pathname,
      );
    };
  }, [pathname, search, setAlertModal]);

  // 초기 하드로드 페이지뷰(Page View)는 head 공통스크립트(LayoutHeadExternalSDKs)가 이미 전송하므로
  // 첫 마운트는 건너뛰기 위한 플래그
  const hasMountedRef = useRef(false);

  // 네이버 공통 페이지뷰(Page View) — SPA 라우트 전환부터만 재집계 (첫 마운트는 head 초기 페이지뷰와 중복되므로 제외)
  // biome-ignore lint/correctness/useExhaustiveDependencies: pathname 변경 시에만 페이지뷰를 재집계해야 하므로 의도적으로 deps에 포함
  useEffect(() => {
    if (!hasMountedRef.current) {
      hasMountedRef.current = true;
      return;
    }
    trackNaverPageView();
  }, [pathname]);

  return <></>;
};
